import { request } from '../core';

export const api = {
  hello: request('/api/v1/hello', 'post'),
};

// Sample
// const { data } = api.hello.useQuery(
//   { params: { hello: 1 }, body: {} },
//   { initialData: { world: 20 } },
// );
